import type { IconData } from '@stacksjs/iconify-core'

export const book1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M37.848 44.496c2.55-.219 4.477-2.198 4.664-4.75C42.75 36.516 43 31.365 43 24s-.25-12.517-.488-15.745c-.188-2.554-2.113-4.532-4.664-4.75C34.908 3.252 30.37 3 24 3s-10.909.253-13.848.504c-2.55.219-4.476 2.197-4.664 4.75C5.25 11.484 5 16.635 5 24s.25 12.517.488 15.745c.188 2.554 2.113 4.533 4.664 4.75C13.092 44.748 17.63 45 24 45s10.909-.253 13.848-.504M14 3.242v41.516M22 12h12m-12 7h6\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default book1
